import {
  FETCH_PUBLICACIONES,
  FETCH_PUBLICACION,
  EDIT_PUBLICACION,
  FETCH_TIPOPUBLICACION,
  IS_LOADED_TIPO_PUBLICACION_IN_SELLER_TAB,
  FETCH_ESTADOSVARIACIONES,
  FETCH_MARCAS,
  FETCH_CATEGORIAS,
  FETCH_MOTIVOS,
  SET_FILTRO_PUBLICACIONES,
  SE_MODIFICARON_IMAGENES,
  LOADING_PUBLICACIONES
} from './types';

import {
  fetchPublicacionesApi,
  fetchPublicacionApi,
  fetchTipoPublicacionApi,
  fetchVariacionesApi,
  fetchMarcasApi,
  fetchCategoriasApi,
  fetchCategoriaApi,
  fetchMotivosRevisionApi
} from '../api/axios';

import {
  nuevaPublicacion,
  mapPublicacion
} from '../helper/publicacionHelper'

export const seModificaronImagenes = (boolean) => dispatch => {
  dispatch({
    type: SE_MODIFICARON_IMAGENES,
    payload: boolean
  });
}

export const setFiltroPublicacion = (filtro) => dispatch => {
  dispatch({
    type: SET_FILTRO_PUBLICACIONES,
    payload: filtro
  });
}

export const fetchPublicaciones = (params) => async dispatch => {
  dispatch({
    type: LOADING_PUBLICACIONES,
    payload: true
  });

  const req = fetchPublicacionesApi(params);
  req.then((publicaciones) => {
    
    if (publicaciones.elementos != undefined) {
      publicaciones.elementos.forEach((p, index) => {
        publicaciones.elementos[index]["imagen"] = p.imagenes.shift();
      });
    }

    dispatch({
      type: FETCH_PUBLICACIONES,
      payload: publicaciones
    });

    dispatch({
      type: LOADING_PUBLICACIONES,
      payload: false
    });

  })
}

export const fetchTiposPublicacion = (idSeller) => async dispatch => {
  const req = fetchTipoPublicacionApi(idSeller);
  req.then((tipos) => {

    dispatch({
      type: IS_LOADED_TIPO_PUBLICACION_IN_SELLER_TAB,
      payload: true
    });

    dispatch({
      type: FETCH_TIPOPUBLICACION,
      payload: tipos.tiposPublicaciones
    });
  })
}

export const loadedTipoPublicacion = (value) => dispatch => {
  dispatch({
    type: IS_LOADED_TIPO_PUBLICACION_IN_SELLER_TAB,
    payload: value
  });
}

export const fetchPublicacion = (id, idSeller) => async dispatch => {
  if (typeof id !== 'undefined' && typeof idSeller !== 'undefined') {

    const req = fetchPublicacionApi(id);
    req.then(publicacion => {
      return new Promise((resolve) => {
        dispatch({
          type: FETCH_PUBLICACION,
          payload: mapPublicacion(publicacion.elementos.shift())
        });
        resolve();
      });
    });
  } else {
    dispatch({
      type: FETCH_PUBLICACION,
      payload: nuevaPublicacion()
    });
  }
}

export const editPublicacion = (publicacion) => dispatch => {
    console.log("matecocido", publicacion)
  return new Promise((resolve) => {
    dispatch({
      type: EDIT_PUBLICACION,
      payload: publicacion
    });
    resolve();
  });
}

export const fetchVariaciones = () => async dispatch => {
  const req = fetchVariacionesApi();
  req.then((variaciones) => {

    dispatch({
      type: FETCH_ESTADOSVARIACIONES,
      payload: variaciones.estados
    });
  })
}

export const fetchMarcas = (descripcion = "") => async dispatch => {
  let options = [];

  const req = fetchMarcasApi(descripcion);
  req.then((marcas) => {
    marcas.elementos.map((marca) => options.unshift({ value: marca.codigo, label: marca.descripcion }));
    dispatch({
      type: FETCH_MARCAS,
      payload: options
    });
  })
}

export const fetchCategorias = (descripcion = "") => async dispatch => {
  let options = [];

  const req = fetchCategoriasApi(descripcion);
  req.then((categorias) => {

    if (categorias.elementos != undefined) {
      categorias.elementos.map((categoria) => options.unshift({ value: categoria.codigo, label: categoria.descripcion }));
    }

    dispatch({
      type: FETCH_CATEGORIAS,
      payload: options
    });
  })
}

export const fetchCategoria = (codigo) => async dispatch => {
  const req = fetchCategoriaApi(codigo);

  req.then((response) => {

    let options = { value: response.subFamilia.descripcion, label: response.subFamilia.descripcion };

    dispatch({
      type: FETCH_CATEGORIAS,
      payload: options
    });
  })
}

export const fetchMotivosRevision = () => async dispatch => {
  const req = fetchMotivosRevisionApi();

  req.then((response) => {
    dispatch({
      type: FETCH_MOTIVOS,
      payload: response.motivos
    })
  })
}